function preencherZero(num) {
    if (num < 10) {
        return "0" + num;
    } else {
        return num;
    }
}

function formataData(data) {
    const d = new Date(data);
    return (
        preencherZero(d.getDate()) +
        "/" +
        preencherZero(d.getMonth() + 1) +
        "/" +
        d.getFullYear() +
        " " +
        d.getHours() +
        ":" +
        preencherZero(d.getMinutes())
    );
}

function limite(texto, size = 45) {
    if (texto.length <= size) {
        return texto;
    }

    return texto.substring(0, size - 3) + "...";
}

function formataDataParaApi(data) {
    const d = new Date(data);
    return (
        d.getFullYear() +
        "-" +
        preencherZero(d.getMonth() + 1) +
        "-" +
        preencherZero(d.getDate()) +
        " " +
        preencherZero(d.getHours()) +
        ":" +
        preencherZero(d.getMinutes()) +
        ":" +
        preencherZero(d.getSeconds())
    );
}

export const INTERVALO_ATUALIZACAO_MS = 120000; // 2minutes

/**
 * Recursively flattens all values from an object (including nested arrays and objects)
 * into a single lowercase string, separated by spaces.
 *
 * @param {Object|Array|any} obj - The input object, array, or value to flatten.
 * @returns {string} A single string containing all flattened values in lowercase, separated by spaces.
 */
export function flattenValuesToString(obj) {
    const values = [];

    function collectValues(item) {
        if (item == null) return;
        if (Array.isArray(item)) {
            item.forEach(collectValues);
        } else if (typeof item === "object") {
            Object.values(item).forEach(collectValues);
        } else {
            values.push(String(item).toLowerCase());
        }
    }

    collectValues(obj);
    for (let i = 0; i < values.length; i++) {
        values[i] = values[i].replace(/[,;!?/-]/g, "");
    }
    return values.join(" ");
}

export default {
    formataData,
    limite,
    formataDataParaApi,
};
